import React,{useState} from 'react'
import MaterialTable from 'material-table'
import {useDispatch ,useSelector} from 'react-redux'
import Navbar from '../../components/navbar/Navbar'
import Sidebar from '../../components/sidebar/Sidebar'
import { Link } from 'react-router-dom';
import './Services.scss'
import { generatePublicUrl } from '../../urlConfig';
import { GetProductById, getProducts } from '../../actions/product.action'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment/moment'
import { Avatar } from '@mui/material'

const Services = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProducts());
  }, [])
  const {t}= useTranslation()

  const GroupsColumns = [

    {  title: t("image"), maxWidth:"60px" ,field: "images",render:(row)=><Avatar src={generatePublicUrl(row?.images[0])}  /> },
    {  title: t("deal"), field:"name",  },
    {  title: t("status"), field: "state", render: (row)=> <div
    className={`${
      row.state === "waiting_confirmation"
        ? "bg-#FFCC00"
        : "bg-green-300"
       } className`}
  >
    {row.state}
  </div>
},
    {  title: t("totalPrice"), field:"priceTotal", },
    {  title: t("originalPrice"), field:"originalPrice", },
    {  title: t("sellerPrice"), field:"SellerPrice", },
    {  title: t("WarrantPeriod"), field:"WarrantPeriod", },
    {  title:  t("deliveryTerm"), field:"deliveryTerm", },
    {   title: t("actions"), field:"_id", render:(row)=> <div > 
                               <Link onClick={()=>{
      let id = row?._id
      dispatch(GetProductById(id))
    } } to={`view/${row?._id}`}  className="className"> {t("view")}</Link>
                               </div>},
  ];
  const services = useSelector((state)=>state.product.products)
  const [data, setData] = useState(services)


  const row = [];

  services &&
    services.forEach((item) => {
      row.push({
        _id: item._id,
        images:item?.images,
        name: item.name,
        priceTotal: item.priceTotal + " " + t("dz"),
        Stock: item.stock,
        deliveryTerm: item?.deliveryTerm,
        originalPrice: item?.originalPrice + " " + t("dz"),
        state: item?.state,
        type: item?.type,
        WarrantPeriod: item?.WarrantPeriod,
        sold: item?.sold_out,
        SellerPrice : item?.SellerPrice + " " + t("dz"),
        

      });
    });


  
  /*const GroupsColumns = [
    {  title: "actions", field:"images[0] ", render:(row)=> <div>  <img className="cellImg" src={generatePublicUrl(row?.images[0])} alt="avatar" /></div>},
    {  title: "title", field:"name", },
    {  title: "state", field:"state", },
    {  title: "category", field:"category?.name",render: (rowData) => rowData.category?.name  },
    {  title: "seller", field: "shopId.firstname", render: (row) => <div>{row.shopId.firstname} {row.shopId.lastname}</div> },
    {  title: "priceTotal", field:"priceTotal", },
    {  title: "originalPrice", field:"originalPrice", },
    {  title: "WarrantPeriod", field:"WarrantPeriod", },
    {  title: "deliveryTerm", field:"deliveryTerm", },
    {  title: "actions", field:"_id", render:(row)=> <div className='cellAction'> <Link onClick={()=>{
      let id = row?._id
      dispatch(GetProductById(id))
    } } to={`view/${row?._id}`}  className="viewButton">view</Link>{console.log(row)} </div>},
    {  title: "createdAt", field:"createdAt", },
  
  
  ];*/


  return (
    <div className="list">
    <Sidebar />
    <div className="listContainer">
      <Navbar/>
      <div className='datatable' style={{ maxWidth: '100%', overflowX: 'auto' }}>
                    <MaterialTable columns={GroupsColumns} data={row} title="our Services"
                        options={{exportButton:true}}
                    />
            </div>

    </div>
  </div>
  )
}

export default Services